import defaultConfig from './default.json';
import activeConfig from './active.json';

// Deep merge: active vendor config over default (fills in any missing fields)
function deepMerge(target, source) {
  const result = { ...target };
  for (const key of Object.keys(source)) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      result[key] = deepMerge(target[key] || {}, source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
}

const vendorConfig = activeConfig.vendorId === 'onchain'
  ? defaultConfig
  : deepMerge(defaultConfig, activeConfig);

export default vendorConfig;

export const isWhitelabel = vendorConfig.vendorId !== 'onchain';
export const vendorId = vendorConfig.vendorId;
export const branding = vendorConfig.branding;
export const features = vendorConfig.features;
export const vendorLinks = vendorConfig.links;
export const vendorAuth = vendorConfig.auth;
export const vendorAgency = vendorConfig.agency;
export const vendorTheme = vendorConfig.theme;
